// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"3f011147","161":"284c67c2","176":"3e54a2a9","445":"e93abf44","640":"9b440b61"}[chunkId] + ".chunk.js";
};